import { getDB } from '../core';
import type { HistoryItem } from '@/types';
import { HISTORY_MAX_ITEMS } from '@/types';

export async function addHistoryItem(item: HistoryItem, maxItems = HISTORY_MAX_ITEMS): Promise<void> {
  const db = await getDB();
  await db.put('history', item);
  // Enforce max limit
  const all = await db.getAllFromIndex('history', 'by-created');
  if (all.length > maxItems) {
    const toDelete = all.slice(0, all.length - maxItems);
    for (const h of toDelete) await db.delete('history', h.id);
  }
}

export async function getAllHistory(): Promise<HistoryItem[]> {
  const db = await getDB();
  const all = await db.getAllFromIndex('history', 'by-created');
  return all.reverse(); // newest first
}

export async function deleteHistoryItem(id: string): Promise<void> {
  const db = await getDB();
  await db.delete('history', id);
}

export async function clearHistory(): Promise<void> {
  const db = await getDB();
  await db.clear('history');
}
